import React from "react"

import { AppSitesAutocomplete } from "@components"
import { BACKEND_APIS } from "@constants"
import { errors, mainSite, sites } from "@signals"
import { chainFinish } from '@components/NewCommonFilters/@services/chainFinish'


export default function AppCommonFiltersSitesAutocomplete({ onOptions, onFinishAjax, ...props }) {

	return <AppSitesAutocomplete
		value={sites.value}
		error={errors.value?.siteID}
		onChange={e => sites.value = e.target.value}
		excludeOptions={[mainSite.value]}
		urlAjax={`${BACKEND_APIS.MASTER_DATA}/execution/options/sites`}
		onFinishAjax={chainFinish(onFinishAjax, onOptions)}
		{...props}
	/>
}